import Api from "~/service/Api";

class UiMeet3dEventNotificationRepository {
  fetch(query) {
    return Api.get("/ui-meet-3d/event-notifications", query);
  }

  fetchOne(uiMeet3dEventNotificationId) {
    return Api.get(`/ui-meet-3d/event-notifications/${uiMeet3dEventNotificationId}`);
  }
}

export default UiMeet3dEventNotificationRepository;
